import { render, staticRenderFns } from "./applyModal.vue?vue&type=template&id=63cc87fa&scoped=true"
import script from "./applyModal.vue?vue&type=script&lang=js"
export * from "./applyModal.vue?vue&type=script&lang=js"
import style0 from "./applyModal.vue?vue&type=style&index=0&id=63cc87fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cc87fa",
  null
  
)

export default component.exports